<template>
  <el-container class="layout-container">
    <!-- 侧边栏 -->
    <el-aside :width="isCollapse ? '64px' : '200px'" class="sidebar">
      <div class="logo" @click="goHome">
        <span class="logo-icon"><i class="el-icon-s-custom"></i></span>
        <span v-show="!isCollapse" class="logo-text">365n 全平台</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        background-color="#1e282c"
        text-color="#bfcbd9"
        active-text-color="#fff"
        class="sidebar-menu"
        router
      >
        <template v-for="menu in sidebarMenus">
          <!-- 有子菜单 -->
          <el-submenu v-if="menu.children && menu.children.length > 0" :key="menu.id" :index="menu.path">
            <template slot="title">
              <i :class="menu.icon || 'el-icon-menu'"></i>
              <span>{{ menu.name }}</span>
            </template>
            <el-menu-item v-for="child in menu.children" :key="child.id" :index="child.path">
              <i v-if="child.icon" :class="child.icon"></i>
              <span slot="title">{{ child.name }}</span>
            </el-menu-item>
          </el-submenu>
          <!-- 无子菜单 -->
          <el-menu-item v-else :key="menu.id" :index="menu.path">
            <i :class="menu.icon || 'el-icon-menu'"></i>
            <span slot="title">{{ menu.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
      <div class="sidebar-footer">
        <div class="user-info">
          <el-avatar :size="32" icon="el-icon-user-solid" />
          <div v-show="!isCollapse" class="user-text">
            <p class="user-name">{{ user.name }}</p>
            <p class="user-role">{{ user.role }}</p>
          </div>
          <i class="el-icon-switch-button logout-btn" @click="handleLogout" title="退出登录"></i>
        </div>
      </div>
    </el-aside>

    <!-- 主内容区 -->
    <el-container class="main-container">
      <!-- 顶栏 -->
      <el-header class="header" height="64px">
        <div class="header-left">
          <i
            :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            class="collapse-btn"
            @click="toggleSidebar"
          ></i>
          <h2 class="page-title">{{ pageTitle }}</h2>
        </div>
        <div class="header-right">
          <el-badge is-dot class="notice-badge">
            <i class="el-icon-bell"></i>
          </el-badge>
          <el-divider direction="vertical"></el-divider>
          <span class="current-date">当前日期：{{ currentDate }}</span>
          <i class="el-icon-date"></i>
        </div>
      </el-header>

      <!-- 内容区 -->
      <el-main class="content">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Layout',
  data() {
    return {
      isCollapse: false
    }
  },
  computed: {
    ...mapState(['user']),
    // 菜单严格以接口返回为准（只有超级管理员在接口异常时才使用本地兜底菜单）：
    // 之前这里是「接口没返回菜单就用默认菜单」，导致角色权限里没勾「首页数据」时
    // 首页等全部菜单又会冒出来，权限形同虚设
    ...mapGetters(['sidebarMenus', 'firstAccessiblePath']),
    activeMenu() {
      return this.$route.path
    },
    pageTitle() {
      return this.$route.meta.title || '365n 全平台管理中心'
    },
    currentDate() {
      const now = new Date()
      return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
    }
  },
  methods: {
    // 点击 logo 回到第一个有权限的页面（不能固定跳首页，角色可能没有首页数据权限）
    goHome() {
      this.$router.push(this.firstAccessiblePath || '/403')
    },
    toggleSidebar() {
      this.isCollapse = !this.isCollapse
    },
    handleLogout() {
      this.$confirm('确认退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/login')
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.sidebar {
  background-color: #1e282c;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.3s;
}

.logo {
  height: 64px;
  background-color: #E4393C;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  flex-shrink: 0;
}

.logo-icon {
  font-size: 20px;
  margin-right: 6px;
}

.logo-text {
  letter-spacing: 1px;
}

.sidebar-menu {
  flex: 1;
  overflow-y: auto;
  border-right: none;
}

.sidebar-menu .el-menu-item {
  height: 48px;
  line-height: 48px;
}

.sidebar-menu .el-menu-item.is-active {
  background-color: #1a2226 !important;
  border-left: 4px solid #E4393C;
}

.sidebar-menu .el-menu-item:hover {
  background-color: #1a2226 !important;
}

.review-badge {
  margin-left: 8px;
}

.sidebar-footer {
  border-top: 1px solid #2c3a40;
  padding: 12px;
  flex-shrink: 0;
}

.user-info {
  display: flex;
  align-items: center;
  color: #bfcbd9;
  font-size: 12px;
}

.user-text {
  margin-left: 8px;
  flex: 1;
  overflow: hidden;
}

.user-name {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  line-height: 1.2;
}

.user-role {
  color: #909399;
  font-size: 10px;
  margin: 0;
  line-height: 1.4;
}

.logout-btn {
  color: #909399;
  cursor: pointer;
  font-size: 16px;
}

.logout-btn:hover {
  color: #fff;
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
}

.collapse-btn {
  font-size: 20px;
  cursor: pointer;
  color: #606266;
  margin-right: 16px;
}

.collapse-btn:hover {
  color: #E4393C;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
  margin: 0;
}

.header-right {
  display: flex;
  align-items: center;
  color: #606266;
  font-size: 14px;
  gap: 16px;
}

.notice-badge i {
  font-size: 20px;
  cursor: pointer;
  color: #606266;
}

.notice-badge i:hover {
  color: #E4393C;
}

.current-date {
  color: #909399;
}

.content {
  background: #f5f7fa;
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}
</style>
